import { Component, OnInit } from '@angular/core';
import { SelfVerificationService } from '../../service/self-verification.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModErrorComponent } from '../../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-my-qualification-list',
  templateUrl: './my-qualification-list.component.html',
  styleUrls: ['./my-qualification-list.component.css']
})
export class MyQualificationListComponent implements OnInit {
  sites: any = [];
  typeEmployee:string;

  constructor(private dataApi: SelfVerificationService,
    private _snackBar: MatSnackBar, public dialog: MatDialog,
    private spinner: NgxSpinnerService,) { }

  ngOnInit() {

    this.spinner.show("loading");
    this.dataApi.getMyQualifications().subscribe(
      (data)=>{
        if(data){
          this.typeEmployee = data.employeeType;
          this.sites = data.sites;
          
        }else{
          this.sites = []
        }
        this.spinner.hide("loading");

      },
      (err)=>{
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      })
  }

  getlang(){

    return sessionStorage.getItem('lang');
  }
}
